"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureToggles = useFeatureToggles;
var _react = require("react");
var _contexts = require("../contexts");
function useFeatureToggles() {
  const features = (0, _react.useContext)(_contexts.featureTogglesContext);
  return (0, _react.useMemo)(() => ({
    features,
    isFeatureEnabled: feature => features.includes(feature)
  }), [features]);
}
